import React, { useState, useEffect } from "react";
import { Layout, Menu, Affix, Row, Col, Modal, Drawer, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import {
  ContainerOutlined,
  UserOutlined,
  HomeOutlined,
  AppstoreAddOutlined,
  CreditCardOutlined,
  LineChartOutlined,
  FileSyncOutlined,
  MenuOutlined,
  BankOutlined,
} from "@ant-design/icons";
import axios from "axios";
import logo from "../../images/company_logo.jpg";
import RTALogo from "../../images/rta.png";

const { Sider } = Layout;

const SideBar = ({
  openKeys: initialOpenKeys = [],
  updateCollapsed,
  children,
  drawerVisibleValue,
  setDrawerVisibleValue,
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // const [drawerVisible, setDrawerVisible] = useState(false);
  const [openKeys, setOpenKeys] = useState(initialOpenKeys);
  const [loginUser, setLoginUser] = useState();
  const [imageSrc, setImageSrc] = useState(logo);
  // const [imageSrc, setImageSrc] = useState(RTALogo);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [visible, setVisible] = useState("none");
  const [logoVisible, setLogoVisible] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    console.log("AAAA", drawerVisibleValue, setDrawerVisibleValue);
    // setDrawerVisible(drawerVisibleValue);
  }, [drawerVisibleValue]);

  useEffect(() => {
    // setDrawerVisible((prevState) => drawerVisibleValue);

    const user = JSON.parse(localStorage.getItem("loginUser"));
    setLoginUser(user);
    const loginUserToken = JSON.parse(localStorage.getItem("loginUserToken"));

    if (user?.imagePath) {
      const fetchImage = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_IMAGE_URL}/${user.imagePath}`,
            {
              headers: {
                Authorization: `Bearer ${loginUserToken}`,
              },
              responseType: "blob",
            },
          );
          const imageBlob = URL.createObjectURL(response.data);
          setImageSrc(imageBlob);
          // setImageSrc(RTALogo);
        } catch (error) {
          console.error("Failed to fetch user image:", error);
          setImageSrc(logo);
          // setImageSrc(RTALogo);
        }
      };

      fetchImage();
    }

    // Detect screen size changes
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onCollapse = (isCollapsed) => {
    if (updateCollapsed) updateCollapsed(isCollapsed);
    setCollapsed(isCollapsed);
    setVisible(isCollapsed ? "none" : "");
    setLogoVisible(isCollapsed ? "" : "none");
  };

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
  };

  const handleOk = () => {
    localStorage.clear();
    setIsModalVisible(false);
    navigate("/login");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleLogout = () => {
    setIsModalVisible(true);
  };

  // Close drawer when clicking a menu item
  const handleMenuClick = () => {
    if (isMobile) {
      // setDrawerVisible(false);
      setDrawerVisibleValue(false);
    }
  };

  return (
    <>
      {isMobile ? (
        <>
          {/* Mobile Menu Button */}

          {/* Mobile Drawer */}
          <Drawer
            title="Menu"
            placement="left"
            closable
            onClose={() => {
              // setDrawerVisible(false);
              setDrawerVisibleValue(false);
            }}
            visible={drawerVisibleValue}
            style={{
              width: "75%",
            }}
          >
            <Link to="/">
              <img
                src={imageSrc}
                className="logo"
                alt="logo"
                style={{
                  height: "64px",
                  marginLeft: "1.5rem",
                  width: 150,
                  marginBottom: "1rem",
                  objectFit: "contain",
                }}
              />
            </Link>
            <Menu mode="vertical" onClick={handleMenuClick}>
              <Menu.Item key="/" icon={<HomeOutlined />}>
                <Link style={{ textDecoration: "none" }} to="/">
                  Home
                </Link>
              </Menu.Item>
              <Menu.Item key="/enquiryForm" icon={<ContainerOutlined />}>
                <Link style={{ textDecoration: "none" }} to="/enquiryForm">
                  Enquiry
                </Link>
              </Menu.Item>
              {loginUser?.userRole === "ADMIN" && (
                <>
                  <Menu.Item key="/enquiryChart" icon={<LineChartOutlined />}>
                    <Link style={{ textDecoration: "none" }} to="/enquiryChart">
                      Review Summary
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/transactionManagement"
                    icon={<CreditCardOutlined />}
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/transactionManagement"
                    >
                      Transaction Management
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/coreTransactionManagement"
                    icon={<FileSyncOutlined />}
                  >
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/coreTransactionManagement"
                    >
                      Callback Core
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="/merchantForm" icon={<AppstoreAddOutlined />}>
                    <Link style={{ textDecoration: "none" }} to="/merchantForm">
                      Merchant Form
                    </Link>
                  </Menu.Item>
                </>
              )}
              <Menu.Item
                key="/logout"
                icon={<UserOutlined />}
                onClick={handleLogout}
              >
                Logout
              </Menu.Item>
            </Menu>
          </Drawer>
        </>
      ) : (
        <Sider
          style={{ backgroundColor: "gray" }}
          collapsible
          collapsed={collapsed}
          onCollapse={onCollapse}
          width={300}
        >
          <Affix>
            <div>
              <div style={{ display: logoVisible }}>
                <Link to="/">
                  <img
                    src={imageSrc}
                    className="logo"
                    alt="logo"
                    style={{
                      height: "45px",
                      marginLeft: "1rem",
                      width: 45,
                      objectFit: "contain",
                    }}
                  />
                </Link>
              </div>

              <div style={{ display: visible }}>
                <Link to="/">
                  <img
                    src={imageSrc}
                    className="logo"
                    alt="logo"
                    style={{
                      height: "64px",
                      marginLeft: "1rem",
                      width: 150,
                      marginTop: "1rem",
                      objectFit: "contain",
                    }}
                  />
                </Link>
                <Row>
                  <Col span={12}></Col>
                  <Col
                    span={12}
                    style={{
                      textAlign: "right",
                      paddingRight: ".5rem",
                      color: "white",
                    }}
                  >
                    {loginUser?.username}
                  </Col>
                </Row>
              </div>

              <Menu
                theme="light"
                mode="inline"
                openKeys={openKeys}
                onOpenChange={onOpenChange}
              >
                <Menu.Item key="/" icon={<HomeOutlined />}>
                  <Link style={{ textDecoration: "none" }} to="/">
                    Home
                  </Link>
                </Menu.Item>
                <Menu.Item key="/enquiryForm" icon={<ContainerOutlined />}>
                  <Link style={{ textDecoration: "none" }} to="/enquiryForm">
                    Enquiry
                  </Link>
                </Menu.Item>
                {loginUser && loginUser.userRole === "ADMIN" ? (
                  <>
                    <Menu.Item key="/enquiryChart" icon={<LineChartOutlined />}>
                      <Link
                        style={{ textDecoration: "none" }}
                        to="/enquiryChart"
                      >
                        Review Summary
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/transactionManagement"
                      icon={<CreditCardOutlined />}
                    >
                      <Link
                        style={{ textDecoration: "none" }}
                        to="/transactionManagement"
                      >
                        Transaction Management
                      </Link>
                    </Menu.Item>

                    <Menu.Item
                      key="/coreTransactionManagement"
                      icon={<FileSyncOutlined />}
                    >
                      <Link
                        style={{ textDecoration: "none" }}
                        to="/coreTransactionManagement"
                      >
                        Callback Core
                      </Link>
                    </Menu.Item>
                    <Menu.Item
                      key="/merchantForm"
                      icon={<AppstoreAddOutlined />}
                    >
                      <Link
                        style={{ textDecoration: "none" }}
                        to="/merchantForm"
                      >
                        Merchant Form
                      </Link>
                    </Menu.Item>
                    <Menu.Item key="/bankManagement" icon={<BankOutlined />}>
                      <Link
                        style={{ textDecoration: "none" }}
                        to="/bankManagement"
                      >
                        Bank Management
                      </Link>
                    </Menu.Item>
                  </>
                ) : (
                  ""
                )}

                <Menu.Item key="/logout" icon={<UserOutlined />}>
                  <a onClick={handleLogout}>Logout</a>
                </Menu.Item>
                <Modal
                  title="Confirm Logout"
                  visible={isModalVisible}
                  onOk={handleOk}
                  onCancel={handleCancel}
                  okText="Logout"
                  cancelText="No"
                  okButtonProps={{ style: { backgroundColor: "#585656" } }} // Optional: style the ok button
                >
                  <p>Are you sure you want to log out?</p>
                </Modal>
              </Menu>
            </div>
          </Affix>
          {children}
        </Sider>
      )}

      {/* Logout Confirmation Modal */}
      <Modal
        title="Confirm Logout"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Logout"
        cancelText="Cancel"
        okButtonProps={{ style: { backgroundColor: "#585656" } }}
      >
        <p>Are you sure you want to log out?</p>
      </Modal>
    </>
  );
};

export default SideBar;
